import React, { Fragment, useEffect, useState } from 'react';
import {
    Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Label, Button, Card, CardBody, Badge,Table
} from "reactstrap";
import TicketModal from './ticket-modal';
import ViewPolicyModal from '../../sales/policies/view-policy-details/view-policy-modal';
import { saveAs } from 'file-saver';
import { downloadDocumentCertificate } from '../../../api/dealership';
import { toast } from 'react-toastify';
import ViewCashifyPolicyModal from '../../sales/policies/view-policy-details/view-cashify-policy-modal';

const PolicyCancellationModal = (props) => {
    const [documentUniqueCode, setDocumentUniqueCode] = useState(null);
    const [policyDocumentId, setPolicyDocumentId] = useState("");
    const [bookingId, setBookingId] = useState("");
    const [isDownloading, setIsDownloading] = useState(false);
    const { rowData } = props
    useEffect(() => {
      if (rowData?.payload) {
          console.log("rowData-----1>", rowData)
          const payloadData = JSON.parse(rowData.payload);
          console.log(payloadData,'payloadData12345444')
          const document_unique_code = payloadData?.reject?.updateCriteria?.document_unique_code ? payloadData?.reject?.updateCriteria?.document_unique_code : payloadData?.reject?.updateCriteria?.policy_no  ;
          console.log( payloadData?.reject?.updateCriteria?.document_unique_code,'document_unique_code')
          setDocumentUniqueCode(document_unique_code);
          const document_id = payloadData?.reject?.updateCriteria;
          setPolicyDocumentId(document_id);
          const booking_id = rowData?.document;
          setBookingId(booking_id);
        //   console.log("payloadData", payloadData)
      }
    }, [rowData]);
    const [viewPolicyDetailspModal, setPolicyDetailsModal] = useState(false);
    const togglePolicyDetailsModal = () => setPolicyDetailsModal(!viewPolicyDetailspModal);

    const viewPolicyDetailsModal = () => {
        togglePolicyDetailsModal();
    };

    const handleGenerateCertificate = async (documentNo) => {
        try {
          setIsDownloading(true);
          const fileBlob = await downloadDocumentCertificate(documentNo);
          const result = fileBlob?.data?.result;
          const timestamp = new Date().toISOString().replace(/:/g, "-");
          const fileName = (result);
          saveAs(fileName);
          setIsDownloading(false);
          toast.success("Certificate generate successfully!");
    
        } catch (error) {
          console.error("Failed to generate certificate:", error);
          toast.error("Error generating certificate. Please try again.");
        } finally {
          setIsDownloading(false); 
        }
      };

    return (
        <Fragment>
                    <Row>
                        {/* <Col xs="12" className='mb-2'>
                            Policy Cancellation Request
                        </Col> */}
                        {/* <Col xs="12">
                            <p>
                                status:<Badge color="warning" className='ml-1'>pending</Badge>
                            </p>
                        </Col> */}
                    </Row>
                <TicketModal data={props.rowData} />
                    <Row>
                        <Col sm="12">
                            <Table className="custom-table table-sm">
                                <tbody>
                                    <tr>
                                    <th>Document No</th>
                                    {/* <td onClick={viewPolicyDetailsModal}>{policyData}</td> */}
                                    <td style={{ textDecoration: 'underline', color: 'blue' }}><a href="#modal" onClick={viewPolicyDetailsModal}>{documentUniqueCode}</a></td>
                                    </tr>  
                                  {rowData?.module_id != 2 &&   
                                  <> 
                                     <tr>
                                              <th>COI number</th>
                                              <td>{bookingId}</td>
                                     </tr>

                                     <tr>
                                      <th>COA</th>
                                              {/* <td onClick={viewPolicyDetailsModal}>{policyData}</td> */}
                                              <td style={{ textDecoration: 'underline', color: 'blue' }}>
                                                  <Button
                                                                color="primary"
                                                                size="xs"
                                                                disabled={isDownloading} // Disable button when generating
                                                                onClick={() => handleGenerateCertificate(documentUniqueCode)}
                                                              >
                                                                {isDownloading ? (
                                                                  <>
                                                                    Generating...
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                      <i className="fa fa-download"></i>
                                                                  </>
                                                                )}
                                                              </Button>
                                              </td>
                                      </tr>
                                  </>  
                                    }      
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {viewPolicyDetailspModal && (
                        rowData?.module_id === 2 ? (
                            <ViewCashifyPolicyModal
                                isOpen={viewPolicyDetailspModal} // Or simply isOpen={true}
                                toggle={togglePolicyDetailsModal}
                                selectedPolicyData={policyDocumentId}
                            />
                        ) : (
                            <ViewPolicyModal
                                isOpen={viewPolicyDetailspModal} // Or simply isOpen={true}
                                toggle={togglePolicyDetailsModal}
                                selectedPolicyData={policyDocumentId}
                            />
                        )
                    )}


        </Fragment>
    );

}

export default PolicyCancellationModal;